exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-icon-wrapper[data-v-52399269]{text-align:center;padding-top:20px}.header-icon-wrapper .v-icon[data-v-52399269]{font-size:3rem;padding:25px;border-radius:50%;border:4px solid #3fa2f7}.wrapper-title[data-v-52399269]{text-align:center;margin-top:5%;color:#3fa2f7}.process-main-actions[data-v-52399269]{text-align:center;padding-top:6%;padding-bottom:4%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52399269","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/JoiningVideoCallDialog.vue
// module id = 987
// module chunks = 0